/*
 * General custom scripts
 */

/**
 * Tab
 */
import { tabHandler } from './front/tabHandler';


tabHandler();

/**
 * clickableElement
 */
import clickableElement from './front/clickableElement';

const clickableElements = document.querySelectorAll( '[data-clickable="true"]' );
new clickableElement( clickableElements );

/**
 * WACG
 */
import wcag from './front/WCAG';

new wcag();

/**
 * Header
 */
import ResponsiveMenu from './front/ResponsiveMenu';
new ResponsiveMenu();

import HeaderEvents from './front/HeaderEvents';
new HeaderEvents();
const header = document.querySelector( 'header.page-header' );
import StickyHeader from './front/StickyHeader';
new StickyHeader( header );

import FastLinksInteractive from './front/FastLinksInteractive';
new FastLinksInteractive( );


